module.exports = __webpack_public_path__ + "img/6002a2e.jpg";